// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchInput_root__bL3Ec","section":"SearchInput_section__cbsqF","input":"SearchInput_input__lFNIf","wrapper":"SearchInput_wrapper__roJWj"};